<div #canvas__container style="width: 100%; position: relative;">
    <canvas #canvas width="150" height="150"></canvas>
    <div class="textInCircle">
        <div>
            <ng-content></ng-content>
        </div>
    </div>
</div>

